import * as React from 'react';
import { TActivity } from '../../../../../../../store/activities/types';
import {
    ActivityItemBody
} from 'app/view/react_components/aside_panel/boardDetails/activity/TabActivity/components/ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../../../../boardDetails/activity/TabActivity/components/ActivityHeader/ActivityHeader';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import { ICardActivityCopyProps } from './types';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardActivityCopy`) : null;

export function CardActivityCopy ({
    activity,
    onLinkClick
}: ICardActivityCopyProps) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { label } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} />}
            activity={activity}
            onLinkClick={onLinkClick}
        />
    );
}
